import { render } from "./onboard-screen-employer.vue?vue&type=template&id=0c90b2f2"
import script from "./onboard-screen-employer.vue?vue&type=script&lang=js"
export * from "./onboard-screen-employer.vue?vue&type=script&lang=js"

import "./onboard-screen-employer.vue?vue&type=style&index=0&id=0c90b2f2&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__